<div class="flex">
    <p ellipsis class="editable-cell__text" [hidden]="isEditing">
        {{ value }}
    </p>
    <input
        *ngIf="isEditing"
        [formControl]="textForm"
        hamInput
        #input
        (keydown.enter)="preventDefault($event); toggleEdit()"
        (keydown.space)="preventDefault($event)"
        stopPropagation
        [value]="editValue ?? value"
    />
    <span *ngIf="isEditing" (click)="toggleEdit()" stopPropagation class="ham-icon">
        <i class="check-icon"></i>
    </span>
    <span *ngIf="!isEditing" class="ham-icon pen-icon" stopPropagation (click)="toggleEdit()">
        <i class="pen-outline-icon"></i>
    </span>
</div>
